import { keyframes, css } from 'styled-components';
import styled from 'styled-components';
import { Format, StyleColor, navBarButtonWrapperStyle, navBarIconStyle } from '../../../utils/styles-constants';
import { Button } from '../../Button/styles';
import { ParametersPageButton } from '../../ParametersPage/styles';
import { ActionButton } from '../../../utils/driveItem';
import { hexToRgba } from '../../../utils/style';

interface DriveItemDownloadButtonProps {
	isFlickering: boolean;
	color: string;
	action: ActionButton;
}

const flicker = (color: string) => css`${keyframes`
	0% {fill: ${color}; opacity:0;}
	25% {fill: ${color}; opacity:0.5;}
	50% {fill: ${color}; opacity:1;}
`}`;

const iconStyle = `
	cursor: pointer;
	& > svg {
		height: 30px;
		width: 30px;
		transition: all 0.2s;
	}
`;

const DownloadButtonVariants: ({}) = {
	['Bar']: styled(Button)`
		margin: 20px 5px;
		${ (props: DriveItemDownloadButtonProps) => props.action === ActionButton.Update
			? `& > svg {
					fill: ${StyleColor.Blue300};
				}

				@media ${Format.Smartphone} {
					flex-basis: 25%;
				}`

			: `	@media ${Format.Smartphone}, ${Format.Tablet}{
					flex: 0 0 content;
				}
			`}
	`,
	['Icon']: styled('div')`
		${navBarButtonWrapperStyle}
		transition: all 0.2s;

		& > svg {
			${navBarIconStyle}
			${ (props: DriveItemDownloadButtonProps) => props.isFlickering ? css`animation: ${flicker(props.color)} 1s linear infinite;` : ''}
			fill: ${props => props.theme.primary.iconsColor};
		}
	`,
	['IconBold']: styled('div')`
		${iconStyle}
		& > svg {
			${ (props: DriveItemDownloadButtonProps) => props.isFlickering ? css`animation: ${flicker(props.color)} 1s linear infinite;` : ''}
		}
	`,
	['ParametersPage']: styled(ParametersPageButton)`
		background-color: ${(props: DriveItemDownloadButtonProps) => hexToRgba(props.color || StyleColor.Blue600, 10)};
		color: ${(props: DriveItemDownloadButtonProps) => props.color || StyleColor.Blue600};

		& div {
			width: 100%;
			text-align: center;
		}

		&:hover {
			background-color: ${(props: DriveItemDownloadButtonProps) => hexToRgba(props.color || StyleColor.Blue600, 15)};
			color: ${(props: DriveItemDownloadButtonProps) => props.color || StyleColor.Blue600};
		}
	`
};

export { DownloadButtonVariants };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DriveItem/DownloadButton/styles.ts